import { ROUTES } from "../constants/app";

export const redirectUtils = {
  /**
   * Store the current URL for redirect after login
   */
  storeReturnUrl: (url: string) => {
    try {
      sessionStorage.setItem("returnUrl", url);
    } catch (error) {
      console.warn("Failed to store return URL:", error);
    }
  },

  /**
   * Get the stored return URL and clear it from session storage
   */
  getAndClearReturnUrl: (): string | null => {
    try {
      const returnUrl = sessionStorage.getItem("returnUrl");
      //console.log('redirectUtils: Retrieved returnUrl from storage:', returnUrl);
      if (returnUrl) {
        sessionStorage.removeItem("returnUrl");

        // Validate the URL to ensure it's a local route
        const isValid = redirectUtils.isValidLocalRoute(returnUrl);
        //console.log('redirectUtils: URL validation result:', isValid, 'for URL:', returnUrl);
        if (isValid) {
          return returnUrl;
        }
      }
    } catch (error) {
      console.warn("Failed to retrieve return URL:", error);
    }
    return null;
  },

  /**
   * Check if a URL is a valid local route (not external)
   */
  isValidLocalRoute: (url: string): boolean => {
    try {
      // Check if it's a relative path (starts with /)
      if (url.startsWith("/")) {
        // Exclude login and auth-related routes to prevent redirect loops
        const excludedRoutes = [ROUTES.LOGIN, ROUTES.REGISTER, ROUTES.SIGNUP];
        return !excludedRoutes.includes(url as any);
      }
      return false;
    } catch (error) {
      console.warn("Failed to validate route:", error);
      return false;
    }
  },

  /**
   * Get the default redirect URL after login
   */
  getDefaultRedirectUrl: (): string => {
    return ROUTES.HOME;
  },
};
